import { ComponentProps, Fragment } from 'react';
import { VariantProps } from 'tailwind-variants';
import Logo from '../../../../../assets/images/brand/logo-black.png';
import { getDisciplineName } from '../../../../utils/new_discipline';
import { Chip } from '../../../atoms/Chip';
import { Icon } from '../../../atoms/Icon';
import { Typography } from '../../../molecules/Typography';
import { IconContainer, InfoLine } from '../variants';

interface IPaperHeader extends VariantProps<typeof InfoLine> {
  icon: {
    iconType: 'material' | 'svg';
    icon: React.ComponentType<ComponentProps<'svg'>> | string;
  };
  module: string;
  title: string;
}

//Cores fixas para funcionar na impressão
export default function PaperHeader({
  icon,
  color,
  module,
  title,
}: IPaperHeader) {
  return (
    <Fragment>
      <div className='flex flex-row items-end justify-between px-5 pt-2'>
        <div className={IconContainer({ color })}>
          <Icon
            type={icon.iconType}
            Icon={icon.icon}
            className='h-7 w-7 fill-[#fff]'
          />
        </div>
        <img src={Logo} className='mb-1' />
      </div>
      <div className={InfoLine({ color })}>
        <div className='flex flex-row items-center gap-lg'>
          <Typography className='text-[#fff]'>
            {getDisciplineName(module)}
          </Typography>
          <Chip
            variant='filled'
            radius='pill'
            className='bg-[#000]/15 border-none py-2'
          >
            <Typography className='text-[#fff]' weight='bold'>
              {title}
            </Typography>
          </Chip>
        </div>
      </div>
    </Fragment>
  );
}
